import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=15c1aeb2&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SettingsPanel.vue?vue&type=style&index=0&id=15c1aeb2&prod&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "15c1aeb2",
  null
  ,true
)

export default component.exports